import React, {FC, useEffect, useMemo, useRef, useState} from 'react'
import {fetchData, formatNumber, toasterrormsg} from '../../../../reusable'
import {KTIcon} from '../../../../_metronic/helpers'
import {ToastContainer} from 'react-toastify'
import DataTable from 'react-data-table-component'
import moment from 'moment'
import {Link, useLocation} from 'react-router-dom'
import Select from 'react-select'
import { Tr } from '../../../../_metronic/i18n/Tr'

const ViewDetailedRevenueReportsByVendor: FC = () => {
  let  t = Tr()
  const location = useLocation()
  const vendorId = (location.state as any)?.vendorId || ''
   const previousSelectedMonth = (location.state as any)?.previousSelectedMonth || ''
  const previousSelectedYear = (location.state as any)?.previousSelectedYear || ''

  const [paymentDetailList, setPaymentDetailList] = useState([])
  const [orgPaymentDetailList, setOrgPaymentDetailList] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [focus, setFocus] = useState('')

  const [selectedStatus, setSelectedStatus] = useState('') as any

  const [statusList] = useState([
    {value: '0', label: 'pending'},
    {value: '1', label: 'Approved'},
    {value: '2', label: 'Rejected'},
    {value: '3', label: 'Cancelled'},
    {value: '4', label: 'Completed'},
  ]) as any

  const currentMonth = new Date().getMonth() + 1

  const [monthList] = useState([
    {value: '1', label: 'January'},
    {value: '2', label: 'February'},
    {value: '3', label: 'March'},
    {value: '4', label: 'April'},
    {value: '5', label: 'May'},
    {value: '6', label: 'June'},
    {value: '7', label: 'July'},
    {value: '8', label: 'August'},
    {value: '9', label: 'September'},
    {value: '10', label: 'October'},
    {value: '11', label: 'November'},
    {value: '12', label: 'December'},
  ]) as any

  const currentYear = new Date().getFullYear()
  const yearList = Array.from({length: currentYear - 2020 + 1}, (_, i) => ({
    value: (currentYear - i).toString(),
    label: (currentYear - i).toString(),
  }))

  let month = previousSelectedMonth!="" ? previousSelectedMonth  : currentMonth
  let year = previousSelectedYear!="" ? previousSelectedYear  : currentYear
  
  const [selectedMonth, setSelectedMonth] = useState(month) as any
  const [selectedYear, setSelectedYear] = useState(year) as any

  const getMonthStartAndEndDates = (year: number, month: number) => {
    if (!year || !month) {
      return {
        startDate: '',
        endDate: '',
      }
    }
    const startDate = new Date(year, month - 1, 1)
    const endDate = new Date(year, month, 0)

    // Format dates in 'YYYY-MM-DD' to avoid timezone-related issues
    const formattedStartDate = `${String(startDate.getDate()).padStart(2, '0')}-${String(
      startDate.getMonth() + 1
    ).padStart(2, '0')}-${startDate.getFullYear()}`
    const formattedEndDate = `${String(endDate.getDate()).padStart(2, '0')}-${String(
      endDate.getMonth() + 1
    ).padStart(2, '0')}-${endDate.getFullYear()}`

    return {
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    }
  }

  const clearFields = () => {
    setSelectedMonth(currentMonth)
    setSelectedYear(currentYear)
    InvoiceDataVendorWiseListApiCall('1')
  }

  const formatDate2 = (date: any) => {
    return moment(date).format('DD-MM-YYYY')
  }

  const InvoiceDataVendorWiseListApiCall = async (
    isClear: any,
    year = selectedYear,
    month = selectedMonth
  ) => {
    const {startDate, endDate} = getMonthStartAndEndDates(year, month)

    var param: any = {}
    if (isClear == '1') {
      param = {
        vendorId: vendorId,
        fromDate: startDate,
        toDate: endDate,
      }
    } else {
      if (
        startDate != '' &&
        endDate != '' &&
        endDate != null &&
        startDate != null 
      ) {
        param = {
          vendorId: vendorId,
          fromDate: startDate,
          toDate: endDate,
        }
      } else if (
        startDate != '' &&
        endDate != '' &&
        endDate != null &&
        startDate != null &&
        selectedStatus != ''
      ) {
        param = {
          vendorId: vendorId,
          fromDate: startDate,
          toDate: endDate,
          status: selectedStatus.value,
        }
      } else {
        param = {
          vendorId: vendorId,
          status: selectedStatus.value,
        }
      }
    }

    var res = await fetchData('admin/invoicepropertywisedata', param)

    if (res.status == '200') {
      var data = res.data
      setPaymentDetailList(data)
      setOrgPaymentDetailList(data)
    } else {
      toasterrormsg(res.message)
    }
  }

  // search Coupon
  const paymentDetailSearch = async (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)

    if (text == '' || text == null || text == undefined) {
      setPaymentDetailList(orgPaymentDetailList)
    } else {
      var tmp: any = orgPaymentDetailList.filter((item: any) => {
        return (
          (item.bookingCode != null &&
            item.bookingCode != '' &&
            String(item.bookingCode).toLocaleLowerCase().includes(text)) ||
          (item.toDate != null &&
            item.toDate != '' &&
            String(item.toDate).toLowerCase().includes(text.toLowerCase())) ||
          (item.originalAmount != null &&
            item.originalAmount != '' &&
            String(item.originalAmount).toLowerCase().includes(text.toLowerCase())) ||
          (item.bookingUserName != null &&
            item.bookingUserName != '' &&
            String(item.bookingUserName).toLowerCase().includes(text.toLowerCase())) ||
          (item.totalAmount != null &&
            item.totalAmount != '' &&
            String(item.totalAmount).toLowerCase().includes(text.toLowerCase())) ||
          (item.insayrFee != null &&
            item.insayrFee != '' &&
            String(item.insayrFee).toLowerCase().includes(text.toLowerCase()))
        )
      })
      setPaymentDetailList(tmp)
    }
  }

  const CustomHeader = (props: any) => {
    const inputRef: any = useRef(null)

    // Define the onchange event handler
    const handleChange = async (e: any) => {
      // Focus on the input element when the onchange event is triggered
      await props.customSearch(e, 1)
    }
    useEffect(() => {
      // Check if the ref exists and if the component should be focused
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus()
      }
    }, [props.isfoc])

    return (
      <div className=' d-flex justify-content-between w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 '>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder='Search Payment Details'
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>
      </div>
    )
  }

  // Define your DataTable columns
  var column = useMemo(
    () => [
      {
        name: 'Booking Id',
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5 text-primary under text-decoration-underline cursor-pointer'>
              <Link
                to={
                  row.categoryId == '1'
                    ? '../viewhotelbookingdetails'
                    : row.categoryId == '4'
                    ? '../viewspacebookingdetails'
                    : row.categoryId == '5'
                    ? '../viewtourbookingdetails'
                    : ''
                }
                state={{
                  bookingId: row.bookingId,
                }}
              >
                #{row.bookingCode || ''}
              </Link>
            </div>
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => Number(row.bookingCode),
        width: '222px',
      },

      {
        name: 'Check Out Date',
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.toDate != '' ? formatDate2(row.toDate) : '-'}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.toDate),
        sortFunction: (rowA: any, rowB: any) => {
          const dateA = rowA.toDate ? new Date(rowA.toDate) : null
          const dateB = rowB.toDate ? new Date(rowB.toDate) : null

          // Handle the case where one or both dates are empty
          if (!dateA && !dateB) return 0 // Both dates are empty
          if (!dateA) return 1 // Empty dates go to the end (you can change this to -1 if you want empty first)
          if (!dateB) return -1

          // Sorting logic: Ascending or Descending based on the click
          if (dateA < dateB) return -1 // Ascending
          if (dateA > dateB) return 1 // Descending
          return 0
        },
        filter: true,
        width: '222px',
      },
      {
        name: 'Vendor Name',
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.vendorFullName != '' ? row.vendorFullName : '-'}
            </div>{' '}
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.vendorFullName),
        filter: true,
        width: '222px',
      },
      {
        name: 'Service Type',
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.categoryId == '1'
                ? 'Accommodation'
                : row.categoryId == '4'
                ? 'Space Rental'
                : 'Tour Package'}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.categoryId),
        filter: true,
        width: '222px',
      },
      {
        name: 'Property Type',
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.propertyname != '' ? row.propertyname : '-'}</div>{' '}
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.propertyname),
        filter: true,
        width: '222px',
      },

      {
        name: 'Booking Status',
        cell: (row: any) => (
          <div className='my-3'>
            <label className='form-check form-switch form-check-custom form-check-success form-check-solid '>
              {row.bookingStatus == 0 ? (
                <span className='badge badge-warning mx-2'>Pending</span>
              ) : row.bookingStatus == 1 ? (
                <span className='badge badge-success mx-2'>Approved</span>
              ) : row.bookingStatus == 2 ? (
                <span className='badge badge-light-danger mx-2'>Rejected</span>
              ) : row.bookingStatus == 3 ? (
                <span className='  badge badge-danger mx-2'>Cancelled</span>
              ) : (
                <span className='badge badge-success mx-2'>Completed</span>
              )}
            </label>
          </div>
        ),
        sortable: true,
        filter: true,
        width: '180px',
        selector: (row: any) => String(row.bookingStatus),
      },

      {
        name: 'Original Amount',
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.originalAmount != '' ? formatNumber(parseFloat(row.originalAmount)) : '0 UZS'}
              {/* {row.percentagePaid == '' ? '-' : '12%'} */}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => Number(row.originalAmount),
        filter: true,
        width: '170px',
      },
      {
        name: 'Customer Name',
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.bookingUserName != '' ? row.bookingUserName : '-'}
            </div>{' '}
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.bookingUserName),
        filter: true,
        width: '222px',
      },
      {
        name: 'Final Amount',
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.totalAmount != '' ? formatNumber(parseFloat(row.totalAmount)) : '0 UZS'}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => Number(row.totalAmount),
        filter: true,
        width: '170px',
      },
      {
        name: 'Insayr Service Fee(%)',
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.insayrFee != '' ? row.insayrFee + '%' : '-'}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => Number(row.insayrFee),
        filter: true,
      },

      {
        name: 'Vendor Revenue',
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.insayrRevenue != '' && row.totalAmount != ''
                ? formatNumber(parseFloat(row.totalAmount) - parseFloat(row.insayrRevenue))
                : '-'}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) =>
          Number(
            row.insayrRevenue != '' && row.totalAmount != ''
              ? parseFloat(row.totalAmount) - parseFloat(row.insayrRevenue)
              : '-'
          ),
        filter: true,
        width: '170px',
      },

      {
        name: 'Vendor Payment Status',
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              <label className='form-check form-switch form-check-custom form-check-success form-check-solid '>
                <span className='badge badge-warning mx-2'>Pending</span>
              </label>
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.bookingUserName),
        filter: true,
        width: '222px',
      },
    ],
    [t]
  )

  useEffect(() => {
    InvoiceDataVendorWiseListApiCall('0')
    document.title = 'Insayr | View Detailed Revenue Reports By Vendor'
  }, [])

  return (
    <>
      <div className='container'>
        <div className='justify-content-center d-flex flex-wrap gap-5 mb-6'>
          <div className='filters'>
            <label htmlFor='fromDate' className='fs-4 form-label'>
              Select Month
            </label>
            <Select
              name='selectVendorMonth'
              id='selectVendorMonth'
              placeholder='Select Month'
              isSearchable={true}
              options={monthList}
              value={monthList.find((option: any) => option.value == selectedMonth) || null}
              onChange={(e: any) => {
                setSelectedMonth(e.value)
              }}
            />
          </div>
          <div className='filters'>
            <label htmlFor='fromDate' className='fs-4 form-label'>
              Select Year
            </label>
            <Select
              name='selectVendorYear'
              id='selectVendorYear'
              placeholder='Select Year'
              isSearchable={true}
              options={yearList}
              value={yearList.find((option: any) => option.value == selectedYear) || null}
              onChange={(e: any) => {
                setSelectedYear(e.value)
              }}
            />
          </div>
          <div className='filters'>
            <label htmlFor='SelectStatus' className='fs-4 form-label'>
              Select Status
            </label>
            <Select
              name='SelectStatus'
              id='SelectStatus'
              placeholder='Select Status'
              isSearchable={true}
              options={statusList}
              value={selectedStatus}
              onChange={(e: any) => setSelectedStatus(e)}
              styles={{
                container: (provided) => ({...provided, width: '100%'}),
                control: (provided) => ({...provided, minHeight: 43}),
              }}
            />
          </div>
        </div>
      </div>

      <div className='d-flex justify-content-center mb-5'>
        <div className='col-md-2 mb-3 d-flex align-items-end'>
          <button
            className='btn btn-primary mx-1'
            onClick={() => InvoiceDataVendorWiseListApiCall('0')}
          >
            Apply
          </button>
          <button className='btn btn-danger mx-1' onClick={() => clearFields()}>
            Clear
          </button>
        </div>
      </div>

      <ToastContainer />
      {/* {
        
        orgPaymentDetailList.length > 0 ? */}

      <>
        <DataTable
          columns={column}
          data={paymentDetailList}
          pagination
          paginationServer={false}
          subHeader={true}
          subHeaderComponent={
            <CustomHeader search={searchTerm} isfoc={focus} customSearch={paymentDetailSearch} />
          }
        />
      </>
      {/* :(
          <>
           <div className="text-center px-4">
              <div className='d-flex justify-content-center align-items-center flex-column my-10'>
                <h2 className="fs-2x fw-bold mb-10">There Are No Hotels</h2>
              </div>
              <Link className='btn btn-success monthBtn text-white' id='kt_toolbar_primary_button' style={{color: 'rgb(24, 28, 50)'}} to="../addhotelbasicinfo/" >+ Add Hotels </Link>
              <br/>
            </div>
            <div className="d-flex justify-content-center">
              <img className="mw-100 mh-300px" alt="" src={toAbsoluteUrl("/media/illustrations/sketchy-1/2.png")} />
            </div>
          </>
        )
      } */}
    </>
  )
}

export {ViewDetailedRevenueReportsByVendor}
